export default __webpack_public_path__ + "static/media/0038.a968741c.jpg";